// tokenService.js

const tokenService = (function () {
  let _service;

  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }

  function _setToken(tokenObj) {
    localStorage.setItem("accessToken", tokenObj.accessToken);
    localStorage.setItem("refreshToken", tokenObj.refreshToken);
  }

  function _setAccessToken(accessToken) {
    localStorage.setItem("accessToken", accessToken);
  }

  function _getAccessToken() {
    return localStorage.getItem("accessToken");
  }

  function _getRefreshToken() {
    return localStorage.getItem("refreshToken");
  }

  function _clearToken() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.clear();
  }

  function _setCustomer(id) {
    localStorage.setItem("customerId", id);
  }

  function _getCustomer() {
    return localStorage.getItem("customerId");
  }

  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    setAccessToken: _setAccessToken,
    setCustomer: _setCustomer,
    getCustomer: _getCustomer,
  };
})();
export default tokenService;
